import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import Session from "@Shared/@Utils/session";
const authAdapter = {
  instance: null,
  init(vm) {
    this.instance = new Session(vm);
  },
  get session() {
    return this.instance;
  },
  get ignoreErrorBroadcast() {
    return Session.ignoreErrorBroadcast;
  },
  set ignoreErrorBroadcast(val) {
    Session.ignoreErrorBroadcast = val;
  },
  async renew() {
    await this.session.renew();
  }
};
export default {
  install: Vue => {
    Vue.auth = authAdapter;
    _Object$defineProperties(Vue.prototype, {
      $auth: {
        get() {
          return Vue.auth;
        }
      }
    });
  }
};